import React from 'react';
import {
  Box,
  Button,
  Typography,
  Stack,
} from '@mui/material';
import SuccessCheckSparkle from '../../../components/success-check-sparkle';
import { solidButtonSx, textButtonSx } from '../../login/styles';

const titleSx = {
  fontFamily: 'Satoshi, sans-serif',
  fontWeight: 500,
  fontSize: '28px',
  lineHeight: '40px',
  letterSpacing: 0,
  textAlign: 'center',
  color: '#070707',
} as const;

const TripRequestConfirmationView = ({
  handleViewClick,
  isViewButtonDisabled,
}: {
  handleViewClick: () => void;
  isViewButtonDisabled: boolean;
}): React.ReactElement => {
  const handleCallSupport = () => {
    window.open('tel:8884412418', '_blank');
  };

  return (
    <Box
      sx={{
        width: '100%',
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Stack spacing={2} alignItems="center" width="100%" sx={{ pt: 4 }}>
        <SuccessCheckSparkle />
        <Typography component="h1" sx={titleSx}>
          We&apos;ve Received Your Request
        </Typography>
        <Typography color="text.secondary" textAlign="center">
          We&apos;re reviewing your trip and our specialists will be in touch shortly.
        </Typography>
      </Stack>

      <Stack spacing={2} sx={{ mt: 'auto', pt: 4, width: '100%' }}>
        <Button
          disabled={isViewButtonDisabled}
          onClick={handleViewClick}
          sx={solidButtonSx}
          fullWidth
        >
          Go to My Trip
        </Button>
        <Button
          variant="text"
          fullWidth
          onClick={handleCallSupport}
          sx={textButtonSx}
        >
          Need Help? Call us at 888 441-2418.
        </Button>
      </Stack>
    </Box>
  );
};

export default TripRequestConfirmationView;
